import { FunctionComponent, useCallback, useEffect, useMemo, useRef, useState } from 'react';

import { useCoreDispatch } from '../../../store/CoreStore';
import { useGameStateSlice } from '../../../store/slices/game/selectors';
import { toastActions, ToastsProps } from '../../../store/slices/toast/slice';
import { Icon, Icons } from '../../icons';
import { Toast } from '../../toast/Toast';

export const TableCloseNotifyToastConnected: FunctionComponent<ToastsProps> = ({ msg, timeStamp, ...rest }) => {
  const dispatch = useCoreDispatch();
  const intervalRef = useRef<number | null>(null);
  const duration = useGameStateSlice.getTableCloseNotification()?.duration;
  const [timer, setTimer] = useState<number>(parseInt(duration || '0') * 60);

  useEffect(() => {
    intervalRef.current = window.setInterval(() => {
      setTimer((prev) => prev - 1);
    }, 1000);
    return () => {
      intervalRef.current && clearInterval(intervalRef.current);
    };
  }, []);

  const _dynamicValues = useMemo(() => {
    if (timer) {
      const minutes = Math.floor(timer / 60);
      const seconds = timer - minutes * 60;
      const minutesStr = `0${minutes}`.slice(-2);
      const secondsStr = `0${seconds}`.slice(-2);
      return [`${minutesStr}:${secondsStr}`];
    } else {
      return [];
    }
  }, [timer]);

  const closeFn = useCallback(() => {
    dispatch(toastActions.removeToast(timeStamp));
  }, [dispatch, timeStamp]);

  return (
    <Toast
      message={msg}
      onClose={closeFn}
      {...rest}
      icon={<Icon icon={Icons.Timer} />}
      msgDynamicValues={_dynamicValues}
    />
  );
};
